import Link from "next/link"
import Image from "next/image"
import { Phone, MessageCircle, MapPin, Building2 } from "lucide-react"

const footerLinks = {
  services: [
    { label: "شقق سكنية", href: "#properties" },
    { label: "فيلات", href: "#properties" },
    { label: "دوبلكس", href: "#properties" },
    { label: "وحدات تجارية", href: "#properties" },
  ],
  company: [
    { label: "من نحن", href: "#services" },
    { label: "مشاريعنا", href: "#properties" },
    { label: "الوحدات المتاحة", href: "/units" },
    { label: "تواصل معنا", href: "#contact" },
  ],
}

export function FooterSection() {
  return (
    <footer className="px-6 py-16 border-t border-zinc-900">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2">
            <Link href="/" className="flex items-center gap-3">
              <div className="relative w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
                <Image src="/logo.jpeg" alt="بنايه للعقارات" fill className="object-cover" />
              </div>
              <span className="font-display text-2xl font-bold text-zinc-100">
                بنايه <span className="text-zinc-500 text-lg font-normal">للعقارات</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-zinc-500 max-w-xs">
              شركة بنايه للعقارات - نقدم أفضل العقارات السكنية والتجارية بتصميمات عصرية وتشطيبات فاخرة ومواقع استراتيجية
            </p>
            
            <div className="mt-6 space-y-3">
              <Link
                href="tel:+201212129070"
                className="flex items-center gap-2 text-sm text-zinc-400 hover:text-brand transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span dir="ltr">+20 12 12129070</span>
              </Link>
              <Link
                href="https://wa.me/201212129070"
                target="_blank"
                className="flex items-center gap-2 text-sm text-green-400 hover:text-green-300 transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
                واتساب
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-zinc-100 mb-4">عقاراتنا</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link href={link.href} className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-zinc-100 mb-4">الشركة</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link href={link.href} className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="py-8 border-y border-zinc-900">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 text-sm text-zinc-500">
                <MapPin className="w-4 h-4 text-brand" />
                <span>مصر</span>
              </div>
              <div className="h-4 w-px bg-zinc-800" />
              <Link href="tel:+201212129070" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-brand transition-colors">
                <Phone className="w-4 h-4" />
                <span dir="ltr">+20 12 12129070</span>
              </Link>
              <div className="h-4 w-px bg-zinc-800" />
              <Link href="https://wa.me/201212129070" target="_blank" className="flex items-center gap-2 text-sm text-green-400 hover:text-green-300 transition-colors">
                <MessageCircle className="w-4 h-4" />
                واتساب
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Link
              href="https://www.facebook.com/share/17zCE5mVKx/?mibextid=wwXIfr"
              target="_blank"
              className="text-zinc-500 hover:text-blue-400 transition-colors"
              aria-label="Facebook"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </Link>
          </div>
          <p className="text-sm text-zinc-600">
            © {new Date().getFullYear()} بنايه للعقارات - Benaya Real Estate. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  )
}
